module.exports = __webpack_public_path__ + "img/icon_sec3_02.43e8f86c.png";